import React, { PureComponent } from "react";
import { Route } from "react-router-dom";
import Button from "@material-ui/core/Button";
import VerticalSpace from "./components/VerticalSpace";
// import ButtonAppBar from "./components/ButtonAppBar";
import Grid from "@material-ui/core/Grid";
import SimpleBottomNavigation from "./components/SimpleBottomNav";
import { withRouter } from "react-router-dom";

class ApptConfirmation extends PureComponent {
  constructor(props) {
    super(props);
    const request = this.props.location.state
      ? this.props.location.state.requestForm
      : null;
    this.state = { requestForm: request, paymentRef: this.props.location.state ? this.props.location.state.paymentRef : "" };
    //console.log(request);
  }

  render() {
    const ConfirmButton = props => (
      <Route
        render={({ history }) => (
          <div>
            <Button
              variant="outlined"
              style={{ width: "100%" }}
              onClick={() => {
                history.push({
                  pathname: "/"
                  // ,
                  // state: { airconsaved: true }
                });
              }}
            >
              Proceed
            </Button>
          </div>
        )}
      />
    );

    return (
      <div>
        {/* <ButtonAppBar /> */}
        <div className="account">
          <div className="account__wrapper">
            <div className="account__card">
              <VerticalSpace />
              <div className="card__title">
                <center>
                  <h4 className="bold-text">Payment</h4>
                </center>
                <br />
              </div>
              {this.state.requestForm ? (
                <form className="form form--horizontal">
                  <div className="form__form-group">
                    <p>
                      <b>Payment Successfully Completed</b>
                    </p>
                  </div>
                  <div className="form__form-group">
                    <p>
                      Appt Date: {this.state.requestForm.DateAppt} -{" "}
                      {this.state.requestForm.Slot}
                    </p>
                  </div>
                  <div className="form__form-group">
                    <div>
                      <p>Type:</p>
                      <ol>
                        {this.state.requestForm.Servicing.map(svc => (
                          <li key={svc.ServicingPriceSid}>
                            {svc.ServiceCategory} for {svc.ServiceUnit} Fancoil(s)
                          </li>
                        ))}
                      </ol>
                    </div>
                  </div>

                  <div className="form__form-group">
                    <p>Amount Paid: S$ {this.state.requestForm.Amount}</p>
                  </div>
                  <div className="form__form-group">
                    <p>Receipt: {this.state.paymentRef}</p>
                  </div>
                  <div className="form__form-group">
                    <Grid container spacing={24}>
                      <Grid item xs={3} />
                      <Grid item xs={6}>
                        <ConfirmButton />
                      </Grid>
                      <Grid item xs={3} />
                    </Grid>
                    <VerticalSpace />
                  </div>
                </form>
              ) : (
                <div />
              )}
              <SimpleBottomNavigation value={1} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ApptConfirmation);



// WEBPACK FOOTER //
// ./src/pages/main/ApptConfirmation.js